import { useTranslation } from 'react-i18next';

import { PriceTable } from '../../components/PriceTable';
import { Seo } from '../../components/Seo';
import { PRICES } from '../../data/prices';

export function ModelsPage() {
  const { t } = useTranslation();

  return (
    <>
      <Seo title={t('meta.modelsTitle')} description={t('meta.modelsDescription')} />
      <div className="container page-head">
        <h1>{t('models.title')}</h1>
        <p className="lead">{t('models.lead')}</p>
      </div>
      <div className="container models-list">
        <PriceTable caption={t('models.title')} rows="all" cacheWrite />
        <p className="note">{t('prices.note', { date: PRICES.updated })}</p>
      </div>
    </>
  );
}
